/**
 * ACTIVITY-CORE (L2) — restaurar / purgar elementos de la papelera de catálogo.
 *
 * Restaurar = `deleted_at: null` (el servidor lo registra como `restored`).
 * Purgar = DELETE duro (op DELETE de PowerSync; el servidor deja snapshot
 * completo en el patch como `deleted`). La purga cascada manualmente los
 * vínculos del catálogo (receta, modificadores, variantes, items de combo).
 */
import {
  combo,
  combo_item,
  customer,
  employee,
  eq,
  ingredient,
  menu_category,
  menu_product,
  type PowerSyncDrizzleDB,
  product_modifier_group,
  product_variant,
  promotion,
  recipe_item,
  supplier,
} from "@comandero/powersync";
import { nowISO } from "../utils/date-helpers";
import type { TrashEntityType } from "./queries";

const TABLES = {
  menu_category,
  menu_product,
  product_variant,
  combo,
  ingredient,
  supplier,
  employee,
  customer,
  promotion,
} as const;

/** Restaura un elemento de la papelera (soft-undelete). */
export async function restoreTrashItemMutation(
  db: PowerSyncDrizzleDB,
  entityType: TrashEntityType,
  id: string,
): Promise<void> {
  const table = TABLES[entityType];
  await db.update(table).set({ deleted_at: null, updated_at: nowISO() }).where(eq(table.id, id));
}

/** Purga definitiva (DELETE duro) con cascada manual de vínculos de catálogo. */
export async function purgeTrashItemMutation(
  db: PowerSyncDrizzleDB,
  entityType: TrashEntityType,
  id: string,
): Promise<void> {
  if (entityType === "menu_product") {
    await db.delete(product_modifier_group).where(eq(product_modifier_group.product_id, id));
    await db.delete(recipe_item).where(eq(recipe_item.product_id, id));
    await db.delete(product_variant).where(eq(product_variant.product_id, id));
    await db.delete(combo_item).where(eq(combo_item.product_id, id));
  }
  if (entityType === "combo") {
    await db.delete(combo_item).where(eq(combo_item.combo_id, id));
  }
  if (entityType === "ingredient") {
    await db.delete(recipe_item).where(eq(recipe_item.ingredient_id, id));
  }
  const table = TABLES[entityType];
  await db.delete(table).where(eq(table.id, id));
}
